<h1>Albion Online Meta Items</h1>
<div class="flex-container-row" style="width: 100%">
  <mat-card class="card" style="width: 100%; margin-bottom: 10px">
    <mat-card-content>Explore Albion's kill event statistics with a wide range of filters at your disposal. This works on all servers!</mat-card-content>
    <mat-card-content>Gain insights into the current meta and identify which items yield higher kills/fame.</mat-card-content>
    <mat-card-content>Mouse over the selection menus items and the table headers to get information about what's going on.</mat-card-content>
    <mat-card-content>If you don't choose how to sort the results, it'll default to Total Event Count (1st) and Average Kill Fame (2nd) (basically, most popular items).</mat-card-content>
    <mat-card-content>The data spans back the past 28 days and is refreshed continuously.</mat-card-content>
  </mat-card>
  @if (userSettingsService.isLoggedIn$ | async) {
    <div style="width: 100%; height: 250px">
      @if (chartData.length > 0) {
        <app-chart [data]="chartData" timeUnit="hour" title="Tracked PVP kills per hour"></app-chart>
      }
    </div>
  }
  <div class="flex-container-row" style="width: 100%">
    @if (userSettingsService.isLoggedIn) {
      @if (shopCategories.length) {
        <form [formGroup]="form" class="flex-container-row">
          <!-- MARK: BUTTONS   -->
          <button class="form-item-button" mat-mini-fab (click)="update()" [disabled]="disableUpdate" color="primary" aria-label="Refresh" matTooltip="Load Data">
            <mat-icon>refresh</mat-icon>
          </button>
          <button class="form-item-button" mat-mini-fab (click)="form.reset()" [disabled]="false" color="primary" aria-label="Reset Filters" matTooltip="Reset Filters">
            <mat-icon>close</mat-icon>
          </button>
          <!-- MARK: SLOT TYPE -->
          <mat-form-field class="form-item-large">
            <mat-label>Slot Types {{ getCountString(form.controls.slotTypes, slotTypes.length) }}</mat-label>
            <mat-select [formControl]="form.controls.slotTypes" [multiple]="true" #multiSelect>
              @for (slot of slotTypes; track $index) {
                <mat-option [value]="slot">
                  {{ slot.printName }}
                </mat-option>
              }
            </mat-select>
            <mat-icon (click)="form.controls.slotTypes.setValue([])" matIconSuffix>close_small</mat-icon>
          </mat-form-field>
          <!-- MARK: SHOP CATEGORIES -->
          <mat-form-field class="form-item-large">
            <mat-label>Shop Categories {{ getCountString(form.controls.shopsubcategories, shopSubCategoriesCount) }}</mat-label>
            <mat-select [formControl]="form.controls.shopsubcategories" [multiple]="true">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search" noEntriesFoundLabel="No matches" [formControl]="subFilterControl"></ngx-mat-select-search>
              </mat-option>
              @for (category of shopCategories; track $index) {
                @if (showCategoryGroup(category) || category.displayName.toLowerCase().includes(subFilterControl.value ?? '')) {
                  <mat-optgroup [label]="category.displayName">
                    <mat-icon (click)="selectAllSubCats(category)" [matTooltip]="'Select All'" style="cursor: pointer">done_all</mat-icon>
                    <mat-icon (click)="removeAllSubCats(category)" [matTooltip]="'Remove All'" style="cursor: pointer">close_small</mat-icon>
                    @for (sub of category.subCategories; track $index) {
                      <mat-option [value]="sub" [ngStyle]="{ display: filteredShopSubCategories.includes(sub) ? 'block' : 'none' }">
                        {{ sub.displayName }}
                      </mat-option>
                    }
                  </mat-optgroup>
                }
              }
            </mat-select>
            <mat-icon (click)="form.controls.shopsubcategories.setValue([])" matIconSuffix>close_small</mat-icon>
          </mat-form-field>
          <!-- MARK: KILL EVENT PLAYER ROLE -->
          <mat-form-field class="form-item-large">
            <mat-label>Player Role {{ getCountString(form.controls.killEventPlayerRoles, killEventPlayerRoles.length) }}</mat-label>
            <mat-select [formControl]="form.controls.killEventPlayerRoles" [multiple]="true" #multiSelect>
              @for (role of killEventPlayerRoles; track $index) {
                <mat-option [value]="role">
                  <mat-icon [matTooltip]="role.description">information</mat-icon>
                  {{ role.name }}
                </mat-option>
              }
            </mat-select>
            <mat-icon (click)="form.controls.killEventPlayerRoles.setValue([])" matIconSuffix>close_small</mat-icon>
          </mat-form-field>
          <!-- MARK: FIGHT SIZES -->
          <mat-form-field class="form-item-large">
            <mat-label>Fight Sizes {{ getCountString(form.controls.fightSizes, fightSizes.length) }}</mat-label>
            <mat-select [formControl]="form.controls.fightSizes" [multiple]="true" #multiSelect>
              @for (size of fightSizes; track $index) {
                <mat-option [value]="size">
                  <mat-icon [matTooltip]="size.description">information</mat-icon>
                  {{ size.displayName }}
                </mat-option>
              }
            </mat-select>
            <mat-icon (click)="form.controls.fightSizes.setValue([])" matIconSuffix>close_small</mat-icon>
          </mat-form-field>
          <!-- MARK: TIERS -->
          <mat-form-field class="form-item-medium">
            <mat-label>Tiers {{ getCountString(form.controls.tiers, tiers.length) }}</mat-label>
            <mat-select [formControl]="form.controls.tiers" [multiple]="true" #multiSelect>
              @for (tier of tiers; track $index) {
                <mat-option [value]="tier">
                  {{ tier }}
                </mat-option>
              }
            </mat-select>
            <mat-icon (click)="form.controls.tiers.setValue([])" matIconSuffix>close_small</mat-icon>
          </mat-form-field>
          <!-- MARK: ENCHANTMENTS -->
          <mat-form-field class="form-item-medium">
            <mat-label>Enchs {{ getCountString(form.controls.enchantments, enchantments.length) }}</mat-label>
            <mat-select [formControl]="form.controls.enchantments" [multiple]="true" #multiSelect>
              @for (ench of enchantments; track $index) {
                <mat-option [value]="ench">
                  {{ ench }}
                </mat-option>
              }
            </mat-select>
            <mat-icon (click)="form.controls.enchantments.setValue([])" matIconSuffix>close_small</mat-icon>
          </mat-form-field>
          <!-- MARK: SORTS -->
          <mat-form-field class="form-item-large">
            <mat-label>Sort By {{ getCountString(form.controls.sorts, sorts.length) === '(All)' ? '(Default)' : getCountString(form.controls.sorts, sorts.length) }}</mat-label>
            <mat-select [formControl]="form.controls.sorts" [multiple]="true" [sortComparator]="noCompareFunction">
              @for (sort of sorts; track $index) {
                <mat-option [value]="sort">
                  <mat-icon [matTooltip]="sort.description">information</mat-icon>
                  {{ sort.displayName }}
                  @if (form.controls.sorts.value && form.controls.sorts.value.indexOf(sort) !== -1) {
                    ({{ form.controls.sorts.value.indexOf(sort) + 1 | ordinal }})
                  }
                </mat-option>
              }
            </mat-select>
            <mat-icon (click)="form.controls.sorts.setValue([])" matIconSuffix>close_small</mat-icon>
          </mat-form-field>
          <!-- MARK: MIN ITEMS -->
          <mat-form-field>
            <mat-label>Min Item Count Last 28 days</mat-label>
            <input matInput [formControl]="form.controls.minTotalItemCount" type="number" step="50" min="0" />
          </mat-form-field>
        </form>
      } @else {
        <mat-progress-bar mode="indeterminate" style="padding: 15px 0px"></mat-progress-bar>
      }

      <!-- MARK: TABLE -->
      @if (dataSource && dataSource.data.length && !isLoading) {
        <div class="mat-elevation-z8 table">
          <table mat-table [dataSource]="dataSource">
            <!-- Item Column -->
            <ng-container matColumnDef="item" sticky>
              <th mat-header-cell *matHeaderCellDef>Item</th>
              <td mat-cell *matCellDef="let element">
                <div style="display: flex; align-items: center">
                  <div>
                    <app-item-image [item]="element.item" [size]="50" [hideTooltip]="true" />
                  </div>
                  <div style="display: flex; flex-direction: column; text-align: left">
                    <div>
                      {{ element.item.localizedName }}
                    </div>
                    <div>
                      <app-copy-text-button [text]="element.item.localizedName"></app-copy-text-button>
                      <app-check-price-button [itemUniqueName]="element.item.uniqueName"></app-check-price-button>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>

            <!-- Total Item Count Column -->
            <ng-container matColumnDef="totalItemCount">
              <th mat-header-cell *matHeaderCellDef style="cursor: help" matTooltip="How many times this item was seen in the filtered events">Item Count</th>
              <td mat-cell *matCellDef="let element">{{ element.totalItemCount | smallNumber }}</td>
            </ng-container>

            <!-- Total Player Count Column -->
            <ng-container matColumnDef="totalPlayerCount">
              <th mat-header-cell *matHeaderCellDef style="cursor: help" matTooltip="How many players were using this item in the filtered events">Player Count</th>
              <td mat-cell *matCellDef="let element">{{ element.totalPlayerCount | smallNumber }}</td>
            </ng-container>

            <!-- Total Event Count Column -->
            <ng-container matColumnDef="totalEventCount">
              <th mat-header-cell *matHeaderCellDef style="cursor: help" matTooltip="In how many of the filtered events this item has shown up">Event Count</th>
              <td mat-cell *matCellDef="let element">{{ element.totalEventCount | smallNumber }}</td>
            </ng-container>

            <!-- Total Killer Count Column -->
            <ng-container matColumnDef="totalKillerCount">
              <th mat-header-cell *matHeaderCellDef style="cursor: help" matTooltip="How many players were the killer while using this item in the filtered events">Killer Count</th>
              <td mat-cell *matCellDef="let element">{{ element.totalKillerCount | smallNumber }}</td>
            </ng-container>

            <!-- Total Assistant Count Column -->
            <ng-container matColumnDef="totalAssistantCount">
              <th mat-header-cell *matHeaderCellDef style="cursor: help" matTooltip="How many players were assistants while using this item in the filtered events">Assistant Count</th>
              <td mat-cell *matCellDef="let element">{{ element.totalAssistantCount | smallNumber }}</td>
            </ng-container>

            <!-- Total Victim Count Column -->
            <ng-container matColumnDef="totalVictimCount">
              <th mat-header-cell *matHeaderCellDef style="cursor: help" matTooltip="How many players were killed while using this item in the filtered events">Victim Count</th>
              <td mat-cell *matCellDef="let element">{{ element.totalVictimCount | smallNumber }}</td>
            </ng-container>

            <!-- Kill Death Ratio Column -->
            <ng-container matColumnDef="killDeathRatio">
              <th mat-header-cell *matHeaderCellDef style="cursor: help" matTooltip="Killer Count / Victim Count">KDR</th>
              <td mat-cell *matCellDef="let element">{{ element.killDeathRatio | smallNumber }}</td>
            </ng-container>

            <!-- Total Kill Fame Column -->
            <ng-container matColumnDef="totalKillFame">
              <th mat-header-cell *matHeaderCellDef style="cursor: help" matTooltip="How much kill fame was gained while using this item in the filtered events">Total Kill Fame</th>
              <td mat-cell *matCellDef="let element">{{ element.totalKillFame | smallNumber }}</td>
            </ng-container>

            <!-- Average Kill Fame Column -->
            <ng-container matColumnDef="averageKillFame">
              <th mat-header-cell *matHeaderCellDef style="cursor: help" matTooltip="Total Kill Fame / Player Count">Average Kill Fame</th>
              <td mat-cell *matCellDef="let element">{{ element.averageKillFame | smallNumber }}</td>
            </ng-container>

            <!-- Total Death Fame Column -->
            <ng-container matColumnDef="totalDeathFame">
              <th mat-header-cell *matHeaderCellDef style="cursor: help" matTooltip="How much kill fame was given out (death) while using this item in the filtered events">Total Death Fame</th>
              <td mat-cell *matCellDef="let element">{{ element.totalDeathFame | smallNumber }}</td>
            </ng-container>

            <!-- Average Death Fame Column -->
            <ng-container matColumnDef="averageDeathFame">
              <th mat-header-cell *matHeaderCellDef style="cursor: help" matTooltip="Total Death Fame / Player Count">Average Death Fame</th>
              <td mat-cell *matCellDef="let element">{{ element.averageDeathFame | smallNumber }}</td>
            </ng-container>

            <!-- Total Damage Done Column -->
            <ng-container matColumnDef="totalDamageDone">
              <th mat-header-cell *matHeaderCellDef style="cursor: help" matTooltip="How much damage was done while using this item in the filtered events">Total Damage Done</th>
              <td mat-cell *matCellDef="let element">{{ element.totalDamageDone | smallNumber }}</td>
            </ng-container>

            <!-- Average Damage Done Column -->
            <ng-container matColumnDef="averageDamageDone">
              <th mat-header-cell *matHeaderCellDef style="cursor: help" matTooltip="Total Damage Done / Player Count">Average Damage Done</th>
              <td mat-cell *matCellDef="let element">{{ element.averageDamageDone | smallNumber }}</td>
            </ng-container>

            <!-- Total Support Healing Done Column -->
            <ng-container matColumnDef="totalSupportHealingDone">
              <th mat-header-cell *matHeaderCellDef style="cursor: help" matTooltip="How much healing was done while using this item in the filtered events">Total Support Healing Done</th>
              <td mat-cell *matCellDef="let element">{{ element.totalSupportHealingDone | smallNumber }}</td>
            </ng-container>

            <!-- Average Support Healing Done Column -->
            <ng-container matColumnDef="averageSupportHealingDone">
              <th mat-header-cell *matHeaderCellDef style="cursor: help" matTooltip="Total Heal Done / Player Count">Average Support Healing Done</th>
              <td mat-cell *matCellDef="let element">{{ element.averageSupportHealingDone | smallNumber }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      } @else {
        @if (isLoading) {
          <mat-progress-bar mode="indeterminate" style="padding: 15px 0px"></mat-progress-bar>
        } @else {
          <p>No data to show. Choose your filters above and click the refresh button!</p>
        }
      }
    } @else {
      <div style="margin-top: 15px">
        You need to <button mat-flat-button color="accent" (click)="authService.googleSignIn()"><mat-icon>login</mat-icon>LOGIN</button> to use this tool.
      </div>
    }
  </div>
</div>
